import type { Filters, PackGoModes } from '@/types/packgo.models'

export const PACKGO_MODES: PackGoModes = { AUTO: 'auto', SCAN: 'scan' }

export const NEW_PACKGO_BETA_FEATURE: string = 'new_packgo'

export const NUMBER_OF_DAYS_TO_FETCH_ALL_ORDERS: number = 9999

export const NUMBER_OF_DAYS_TO_FETCH_CUSTOM_DATES: number = -1

export const DEFAULT_FILTERS = {
  integration_id: null,
  date_range: { start: null, end: null, days_ago: NUMBER_OF_DAYS_TO_FETCH_ALL_ORDERS },
  carriers: [],
} satisfies Filters
